import * as InsightsOverrides from 'common/report/insights/util/bookmark-overrides';
import * as FunnelOverrides from 'common/report/funnels/util/bookmark-overrides';
import * as FlowsOverrides from 'common/report/flows/util/bookmark-overrides';
import * as RetentionOverrides from 'common/report/retention/util/bookmark-overrides';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';

import {ChartType} from '../constants';
import {BookmarkType} from '../queries/app-api/bookmark-client';
import {isFunnelOnlyInsightsBookmark, transformBookmarkToMultiMetricBookmark} from '../insights/models/utils';
import {TimeFilter} from './types';

export function getBookmarkParamsWithOverrides({
  bookmarkParams,
  bookmarkType,
  chartTypeOverride,
  timeFilterOverride,
  additionalFilters,
}: {
  bookmarkParams: TODO; // possibly make it work with generics
  bookmarkType: BookmarkType;
  chartTypeOverride: ChartType | null;
  timeFilterOverride: TimeFilter | null;
  additionalFilters: PropertyFilter[];
}): TODO {
  const type = isFunnelOnlyInsightsBookmark(bookmarkParams) ? BookmarkType.Insights : bookmarkType;
  switch (type) {
    case BookmarkType.Insights: {
      bookmarkParams = transformBookmarkToMultiMetricBookmark(bookmarkParams);
      const dateRangeOverride = timeFilterOverride?.dateRange ? new DateRange(timeFilterOverride.dateRange) : null;

      bookmarkParams = InsightsOverrides.getBookmarkParamsWithRelativeValueUpdated(bookmarkParams);

      if (chartTypeOverride) {
        bookmarkParams = InsightsOverrides.getBookmarkParamsWithChartType(bookmarkParams, chartTypeOverride);
      }

      if (dateRangeOverride) {
        bookmarkParams = InsightsOverrides.getBookmarkParamsWithDateRange(bookmarkParams, dateRangeOverride);
      }

      bookmarkParams = InsightsOverrides.getBookmarkParamsWithAdditionalFilters(bookmarkParams, additionalFilters);

      bookmarkParams = InsightsOverrides.updateSortConfig(bookmarkParams);

      break;
    }
    case BookmarkType.Funnels: {
      if (chartTypeOverride) {
        bookmarkParams = FunnelOverrides.getBookmarkParamsWithChartType(bookmarkParams, chartTypeOverride);
      }
      bookmarkParams = FunnelOverrides.getBookmarkParamsWithAdditionalFilters(bookmarkParams, additionalFilters);

      // Dashboard's bookmark API returns params with a "unit" property which isn't valid for Funnels queries
      delete bookmarkParams.unit;

      if (timeFilterOverride?.dateRange) {
        bookmarkParams = FunnelOverrides.getBookmarkParamsWithDateRange(
          bookmarkParams,
          new DateRange(timeFilterOverride.dateRange),
        );
      }

      break;
    }
    case BookmarkType.Flows: {
      const flowsDateRangeOverride = timeFilterOverride?.dateRange ? new DateRange(timeFilterOverride.dateRange) : null;
      bookmarkParams = FlowsOverrides.getBookmarkParamsWithOverrides(
        bookmarkParams,
        chartTypeOverride,
        flowsDateRangeOverride,
        additionalFilters,
      );
      break;
    }
    case BookmarkType.Retention: {
      const dateRangeOverride = timeFilterOverride?.dateRange ? new DateRange(timeFilterOverride.dateRange) : null;

      bookmarkParams = RetentionOverrides.getBookmarkParamsWithOverrides(
        bookmarkParams,
        chartTypeOverride,
        dateRangeOverride,
        additionalFilters,
      );
    }
  }

  return bookmarkParams;
}
